<template>
  <div class="form__field" style="width: 30em">
    <div class="form__field__group">
      <a class="button button--bordered button--primary" @click="e => $emit('click', e)">
        <span class="button__label">{{ label }}</span>
        <span class="button__icon icon-right-open-big"></span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String
  }
};
</script>
